import { Tooltip } from "@mui/material";
import { useState } from "react";
import { Zone, Voucher as VoucherData } from "@tt/common";
import { ReactComponent as CrownSVGIcon} from './crown.svg';

export const VoucherList = (props: Zone) => {
  const [showAll, setShowAll] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const sortedVouchers = [...props.vouchers].sort((a, b) => (b.trust - a.trust))
  return showAll ? 
    <p onClick={() => setShowAll(false)}>
      <>
        {'Vouched by '}
        {sortedVouchers.map((voucher, i, array) => (
          <><Voucher {...voucher} />{i === array.length - 1 ? '' : ', '}</>
        ))}
        {props.vouchers.length && props.anonVouchers ? ` and ${props.anonVouchers} anonymous users` : ''}
      </>
    </p>
  :
    <Tooltip 
        title={'Click to show all'}
        open={showTooltip} 
        onOpen={() => {if (props.vouchers.length > 3) setShowTooltip(true)}}
        onClose={() => setShowTooltip(false)}>
      <p onClick={() => {if (props.vouchers.length > 3) setShowAll(true)}}>
        Vouched by <NamedVouchers {...props} />
        {props.vouchers.length > 3 || (props.vouchers.length && props.anonVouchers) ? ' and ' : ''}
        <VoucherCount {...props} vouchers={sortedVouchers} />
      </p>
    </Tooltip>
}

/*
Vouched by N anonymous users
Vouched by Foo
Vouched by Foo and N anonymous users
Vouched by Foo and Bar
Vouched by Foo, Bar, and N anonymous users
Vouched by Foo, Bar, and Baz
Vouched by Foo, Bar, Baz, and N other users
*/

const NamedVouchers = (props: Zone) => {
  if (props.vouchers.length === 0) return <></>;
  if (props.vouchers.length === 1) return <Voucher {...props.vouchers[0]} />;
  if (props.vouchers.length === 2) return <>
    <Voucher {...props.vouchers[0]} />
    {props.anonVouchers ? ', ' : ' and '}
    <Voucher {...props.vouchers[1]} />
  </>;
  if (props.vouchers.length === 3) return <>
    <Voucher {...props.vouchers[0]} />{', '}
    <Voucher {...props.vouchers[1]} />
    {props.anonVouchers ? ', ' : ' and '}
    <Voucher {...props.vouchers[2]} />
  </>;
  return <>
    <Voucher {...props.vouchers[0]} />{', '}
    <Voucher {...props.vouchers[1]} />{', '}
    <Voucher {...props.vouchers[2]} />
  </>;
}

const getColour = (trust: number): string => {
  if (trust > 100) return '#FFD700'
  if (trust > 50) return '#C0C0C0';
  return '#CD7F32';
}

const Voucher = (props: VoucherData) => (
  <Tooltip title={`${props.trust} trust`}><span><CrownSVGIcon fill={getColour(props.trust)} height={15} width={15} /><span>{props.username}</span></span></Tooltip>
)

const VoucherCount = (props: Zone) => {
  if (props.vouchers.length < 4 && props.anonVouchers === 0) return <></>;
  if (props.vouchers.length < 4) return <>{props.anonVouchers} anonymous users</>;
  return <>{props.anonVouchers + props.vouchers.length - 3} other users</>;
}